// extracted by mini-css-extract-plugin
export var active = "_2j-2";
export var highlight = "_2j-1";
export var highlightLayer = "_2j-0";
export var issuePopover = "_2j-3";
export var statusIcon = "_2j-4";